import React, { useState, createContext } from 'react'
import { EditorSettingsContextType } from './types'

/*
  newly created editor settings must have a translation in the format:
  editor.settings.SETTING_NAME

  i.e: 'editor.settings.addNewPagesAtTheEnd'
*/

interface EditorSettingsProviderProps {
  editorSettingsContext: EditorSettingsContextType
  setEditorSettingsContext: (setting: Record<string, boolean>) => void
  updateEditorSettingsContext: (setting: Record<string, boolean>) => void
  children?: React.ReactNode
}

const defaultEditorSettings: EditorSettingsContextType = {
  addNewPagesAtTheEnd: false,
  addNewPagesAfterCurrentPage: true
}

export const EditorSettingsContext = createContext<EditorSettingsProviderProps>({
  editorSettingsContext: defaultEditorSettings,
  setEditorSettingsContext: () => void 0,
  updateEditorSettingsContext: () => void 0,
  children: null
})

export const EditorSettingsProvider = ({ children }: EditorSettingsProviderProps) => {
  const [ editorSettingsContext, setEditorSettingsContext ] = useState(defaultEditorSettings)

  const updateEditorSettings = (setting: Record<string, boolean>) => {
    // Todo: update editor settings in the backend
    setEditorSettingsContext(setting)
  }



  return (
    <EditorSettingsContext.Provider value={{
      editorSettingsContext,
      setEditorSettingsContext,
      updateEditorSettingsContext: updateEditorSettings,
      children
    }}>
      {children}
    </EditorSettingsContext.Provider>
  )
}

